/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as CustomPropTypes from 'lib/CustomPropTypes';
import { connect } from 'react-redux';
import classNames from 'classnames';

import LeadBorderTop from 'components/LeadBorderTop';
import LeadSquare from 'components/packages/LeadSquare';
import MultiUp from 'components/packages/MultiUp';

import styles from './styles.module.scss';
import teaseStyles from './teaseStyles.module.scss';

export const mapStateToProps = ({ shared }) => ({
  vertical: shared.vertical,
});

@connect(mapStateToProps)
class ThreeFeatured extends Component {
  static propTypes = {
    content: CustomPropTypes.package.isRequired,
    vertical: PropTypes.string.isRequired,
    pkgClassName: PropTypes.string,
  };

  static defaultProps = {
    pkgClassName: 'pkg threeFeatured',
  };

  render() {
    const { content, vertical, pkgClassName } = this.props;

    const { items, metadata: packageMetadata, packageIndex } = content;

    const multiUpPackage = {
      type: 'twoUp',
      headline: {},
      items: [
        ...items.slice(1),
      ],
      metadata: packageMetadata,
    };

    const classes = classNames(
      pkgClassName,
      `pkg-index-${packageIndex}`,
      styles.threeFeatured,
      { [styles.gc]: vertical === 'globalcitizen' },
    );

    const firstItem = items[0];
    const leadSquareContent = firstItem
      ? { ...items[0], metadata: { ...packageMetadata, ...firstItem.metadata } }
      : null;

    return (
      <section
        data-packageid={content.id}
        className={classes}
        data-test="three-featured__section"
      >
        <LeadBorderTop types={['collectionLead']} />
        <LeadSquare
          content={leadSquareContent}
          styles={teaseStyles}
          pkgClassName="leadSquare"
        />
        <div className={classNames(styles.articles, 'layout-grid-container')}>
          <div className="layout-grid-item">
            <MultiUp
              content={multiUpPackage}
              pkgClassName={`pkg multiUp multiUp--${multiUpPackage.type}`}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default ThreeFeatured;
/* eslint-enable react/prefer-stateless-function */
